<template>
  <div v-if="loadingSpinnerStore.globalLoading" class="spinner-container">
    <div class="loading">
      <img class="animation" src="@/assets/img/ui/loading.svg" alt="loading" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useLoadingSpinnerStore } from "~/stores/ui/loadingspinnerstore";
import { onMounted } from "vue";

const loadingSpinnerStore = useLoadingSpinnerStore();

onMounted(() => {
  console.debug("Loading.vue onMounted");
});
</script>

<style scoped lang="scss">
@use "@/sass/components/Loading.scss" as *;
</style>
